// 100 random clients database - 30 Bulgarian clients
export interface Client {
  id: number;
  name: string;
  country: string;
  city: string;
  avatar: string;
  investment: number;
  profit: number;
  joinedDate: string;
}

// Bulgarian names
const bulgarianNames = [
  'Иван Петров', 'Мария Иванова', 'Георги Димитров', 'Елена Николова',
  'Димитър Георгиев', 'Анна Стоянова', 'Николай Костадинов', 'Петър Василев',
  'Стефан Илиев', 'Кристина Михайлова', 'Борислав Ангелов', 'Симона Тодорова',
  'Александър Маринов', 'Виктория Радева', 'Мартин Христов', 'Йорданка Пеева',
  'Пламен Стоев', 'Радослава Ковачева', 'Тодор Александров', 'Лиляна Борисова',
  'Владимир Димитров', 'Галина Иванова', 'Красимир Николов', 'Десислава Георгиева',
  'Станислав Петров', 'Милена Стоянова', 'Йордан Василев', 'Румяна Илиева',
  'Боян Костадинов', 'Цветелина Маринова'
];

// Bulgarian cities
const bulgarianCities = [
  'София', 'Пловдив', 'Варна', 'Бургас', 'Русе', 'Стара Загора',
  'Плевен', 'Сливен', 'Добрич', 'Шумен', 'Перник', 'Хасково',
  'Ямбол', 'Пазарджик', 'Благоевград', 'Велико Търново', 'Враца', 'Габрово',
  'Асеновград', 'Видин', 'Казанлък', 'Кърджали', 'Кюстендил', 'Монтана',
  'Дупница', 'Търговище', 'Силистра', 'Ловеч', 'Разград', 'Сандански'
];

// International names
const internationalNames = [
  // Europe
  'Hans Mueller', 'Sophie Dubois', 'Marco Rossi', 'Emma Schmidt',
  'Jean Martin', 'Luca Bianchi', 'Anna Kowalski', 'Lars Andersen',
  'Elena Popescu', 'Michal Novak', 'Katarina Horvat', 'Andreas Papadopoulos',
  'Sofia Andersson', 'Thomas Müller', 'Isabella Romano', 'Jan De Vries',
  'Natalia Kowalczyk', 'Marko Jovanovic', 'Laura Fernandez', 'Oliver Smith',
  // Asia
  'Wei Chen', 'Yuki Tanaka', 'Priya Sharma', 'Min-ho Kim',
  'Siti Rahman', 'Raj Patel', 'Li Wei', 'Aisha Abdullah',
  'Hiroshi Yamamoto', 'Fatima Al-Rashid', 'Sanjay Gupta', 'Mei Ling',
  'Ahmed Hassan', 'Nurul Islam', 'Kenji Sato', 'Lakshmi Venkatesh',
  // Americas
  'Carlos Silva', 'Maria Santos', 'John Williams', 'Jennifer Brown',
  'Diego Martinez', 'Amanda Johnson', 'Roberto Garcia', 'Jessica Davis',
  'Miguel Lopez', 'Sarah Wilson', 'Fernando Costa', 'Emily Taylor',
  'Jose Rodriguez', 'Ashley Miller', 'Luis Hernandez', 'Michelle Anderson',
  // Africa & Middle East
  'Kwame Asante', 'Amina Diallo', 'Omar Farouk', 'Zainab Ibrahim',
  'Tunde Okafor', 'Nadia Hassan', 'Abdul Rahman', 'Grace Mbeki',
  // Australia & Oceania
  'Jack Thompson', 'Emma Wilson', 'Liam Cooper', 'Zoe Mitchell'
];

// International cities by country
const internationalCities: Record<string, string[]> = {
  'Germany': ['Berlin', 'Munich', 'Hamburg', 'Cologne'],
  'France': ['Paris', 'Lyon', 'Marseille', 'Nice'],
  'Italy': ['Rome', 'Milan', 'Naples', 'Turin'],
  'Spain': ['Madrid', 'Barcelona', 'Valencia', 'Seville'],
  'UK': ['London', 'Manchester', 'Birmingham', 'Glasgow'],
  'Netherlands': ['Amsterdam', 'Rotterdam', 'The Hague', 'Utrecht'],
  'Poland': ['Warsaw', 'Krakow', 'Gdansk', 'Wroclaw'],
  'Romania': ['Bucharest', 'Cluj', 'Timisoara', 'Iasi'],
  'Greece': ['Athens', 'Thessaloniki', 'Patras', 'Heraklion'],
  'Sweden': ['Stockholm', 'Gothenburg', 'Malmö', 'Uppsala'],
  'China': ['Beijing', 'Shanghai', 'Shenzhen', 'Guangzhou'],
  'Japan': ['Tokyo', 'Osaka', 'Yokohama', 'Nagoya'],
  'India': ['Mumbai', 'Delhi', 'Bangalore', 'Chennai'],
  'South Korea': ['Seoul', 'Busan', 'Incheon', 'Daegu'],
  'Singapore': ['Singapore'],
  'UAE': ['Dubai', 'Abu Dhabi', 'Sharjah'],
  'Saudi Arabia': ['Riyadh', 'Jeddah', 'Mecca'],
  'Brazil': ['Sao Paulo', 'Rio de Janeiro', 'Brasilia', 'Salvador'],
  'Mexico': ['Mexico City', 'Guadalajara', 'Monterrey'],
  'Argentina': ['Buenos Aires', 'Cordoba', 'Rosario'],
  'USA': ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Miami'],
  'Canada': ['Toronto', 'Vancouver', 'Montreal', 'Calgary'],
  'Nigeria': ['Lagos', 'Abuja', 'Kano'],
  'South Africa': ['Johannesburg', 'Cape Town', 'Durban'],
  'Egypt': ['Cairo', 'Alexandria', 'Giza'],
  'Australia': ['Sydney', 'Melbourne', 'Brisbane', 'Perth']
};

// Generate Bulgarian clients (30)
const bulgarianClients: Client[] = bulgarianNames.map((name, index) => {
  const investment = [3000, 5000, 10000][Math.floor(Math.random() * 3)];
  const profitRate = investment === 3000 ? 0.20 : investment === 5000 ? 0.30 : 0.50;
  const profit = Math.round(investment * profitRate * (0.8 + Math.random() * 0.4)); // 80-120% of expected
  
  return {
    id: index + 1,
    name,
    country: 'Bulgaria',
    city: bulgarianCities[index],
    avatar: `https://api.dicebear.com/7.x/avataaars/svg?seed=${name.replace(/\s/g, '')}&backgroundColor=b6e3f4`,
    investment,
    profit,
    joinedDate: new Date(Date.now() - Math.random() * 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
  };
});

// Generate international clients (70)
const countries = Object.keys(internationalCities);
const internationalClients: Client[] = internationalNames.map((name, index) => {
  const country = countries[index % countries.length];
  const cities = internationalCities[country];
  const city = cities[Math.floor(Math.random() * cities.length)];
  const investment = [3000, 5000, 10000][Math.floor(Math.random() * 3)];
  const profitRate = investment === 3000 ? 0.20 : investment === 5000 ? 0.30 : 0.50;
  const profit = Math.round(investment * profitRate * (0.8 + Math.random() * 0.4));
  
  return {
    id: index + 31,
    name,
    country,
    city,
    avatar: `https://api.dicebear.com/7.x/avataaars/svg?seed=${name.replace(/\s/g, '')}&backgroundColor=c0aede`,
    investment,
    profit,
    joinedDate: new Date(Date.now() - Math.random() * 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
  };
});

// Combine and export
export const clients: Client[] = [...bulgarianClients, ...internationalClients];

// Get random client
export const getRandomClient = (): Client => {
  return clients[Math.floor(Math.random() * clients.length)];
};